import { render } from "./Permission.vue?vue&type=template&id=7d15fc2a&scoped=true"
import script from "./Permission.vue?vue&type=script&lang=js"
export * from "./Permission.vue?vue&type=script&lang=js"

import "./Permission.vue?vue&type=style&index=0&id=7d15fc2a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7d15fc2a"

export default script